import { render } from "./PatientFilePreview.vue?vue&type=template&id=71244f1b"
import script from "./PatientFilePreview.vue?vue&type=script&lang=js"
export * from "./PatientFilePreview.vue?vue&type=script&lang=js"

import "./PatientFilePreview.vue?vue&type=style&index=0&id=71244f1b&lang=scss"
import "./PatientFilePreview.vue?vue&type=style&index=1&id=71244f1b&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__